import dataMixin from './dataMixin';
import formSubmissionMixin from './formSubmissionMixin';
import validationMixin from './validationMixin';

export default {
  mixins: [validationMixin, dataMixin, formSubmissionMixin],
  methods: {
    async createInstallment(formData) {
      return this.handleSubmit(
        this.validateForm,
        (data) =>
          this.$store.dispatch('installmentCategory/createCategory', data),
        formData,
        {
          successMessage: 'Thêm mới tài khoản thành công',
          errorMessage: 'Thêm mới tài khoản thất bại',
          redirectRoute: 'list-installment',
          resetForm: true,
        },
      );
    },

    async updateInstallment(formData) {
      const id = this.$route.query.id || this.$route.params.id;
      if (!id) {
        this.makeToastFaile('Không tìm thấy ID tài khoản');
        return;
      }

      return this.handleSubmit(
        this.validateForm,
        (data) =>
          this.$store.dispatch('installmentCategory/updateCategory', {
            id,
            ...data,
          }),
        formData,
        {
          successMessage: 'Cập nhật tài khoản thành công',
          errorMessage: 'Cập nhật tài khoản thất bại',
          redirectRoute: 'list-installment',
        },
      );
    },
  },
};
